// @flow

import _ from 'lodash';
import { connect } from 'react-redux';

import { fetchCart } from 'client/actions/cart';
import { fetchActiveApps, resetApp } from 'client/actions/ifpApps';
import CartPlanDetail from 'client/components/cart/CartPlanDetail';

const mapStateToProps: Object = (state) => {
  const { user } = state;
  const locale = _.get(user, 'locale', 'en-US');
  return { locale };
};

export default connect(mapStateToProps, {
  fetchActiveApps,
  fetchCart,
  resetApp,
})(CartPlanDetail);
